import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { ShuttelbussService } from '../../services/shuttlebuss.service';
import { BackOfficeService } from '../../services/backoffice.service';
import { MyConfigService } from '../../services/my-config.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-admin-start',
  templateUrl: './admin-start.component.html',
  styleUrls: ['./admin-start.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AdminStartComponent implements OnInit, OnDestroy {
  componentDestroyed$: Subject<boolean> = new Subject();
  private hostPath: string = JSON.parse(environment.IDENTITY);
  constructor(
    public authService: AuthService,
    public shuttlebussService: ShuttelbussService,
    public backOfficeService: BackOfficeService,
    public myConfigService: MyConfigService,
    private router: Router
  ) { }

  ngOnInit() {
    const config = this.myConfigService.getMyConfig();
    if (config && !config.showAdmin) {
      this.router.navigate(['/start']);
    }
  }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

}
